import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import { MedicalRecordsFiltersResponse } from '@/api';

export type MedicalRecordsFiltersOptions = MedicalRecordsFiltersResponse;

export interface MedicalRecordsUploadDateRange {
  minUploadDate?: string;
  maxUploadDate?: string;
}

interface MedicalRecordsFiltersState {
  filters: MedicalRecordsFiltersOptions;
  selected: MedicalRecordsFiltersOptions;
  selectedUploadDateRange: MedicalRecordsUploadDateRange;
}

const initialState: MedicalRecordsFiltersState = {
  filters: {
    caseStatus: [],
    checkedBy: [],
    documentStatus: [],
    providerTypes: [],
    providers: [],
    uploadedBy: [],
  },
  selected: {
    caseStatus: [],
    checkedBy: [],
    documentStatus: [],
    providerTypes: [],
    providers: [],
    uploadedBy: [],
  },
  selectedUploadDateRange: {},
};

const medicalRecordsFiltersSlice = createSlice({
  name: 'medicalRecordsFilters',
  initialState,
  reducers: {
    setMedicalRecordsFilters(state, action: PayloadAction<MedicalRecordsFiltersOptions>) {
      state.filters = action.payload;
    },
    setSelectedMedicalRecordsFilters(state, action: PayloadAction<MedicalRecordsFiltersOptions>) {
      state.selected = action.payload;
    },
    setSelectedMedicalRecordsUploadDateRange(state, action: PayloadAction<MedicalRecordsUploadDateRange>) {
      state.selectedUploadDateRange = action.payload;
    },
    resetSelectedMedicalRecordsFilters(state) {
      state.selected = initialState.selected;
      state.selectedUploadDateRange = initialState.selectedUploadDateRange;
    },
  },
});

export const {
  setMedicalRecordsFilters,
  setSelectedMedicalRecordsFilters,
  setSelectedMedicalRecordsUploadDateRange,
  resetSelectedMedicalRecordsFilters,
} = medicalRecordsFiltersSlice.actions;

export const selectMedicalRecordsFilters = (state: RootState) => state.medicalRecordsFilters.filters;
export const selectSelectedMedicalRecordsFilters = (state: RootState) => state.medicalRecordsFilters.selected;
export const selectSelectedMedicalRecordsUploadDateRange = (state: RootState) =>
  state.medicalRecordsFilters.selectedUploadDateRange;

export const medicalRecordsFiltersReducer = medicalRecordsFiltersSlice.reducer;
